const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import * as telegram from './telegram'
import * as utils from './utils'
import * as utils_topshot from './utils_topshot'
import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account'

export enum roleType {
  Seller = 1, Buyer = 2
}

export enum filterTypes {
  AllReceived = 1, ReceivedAsSeller = 2, ReceivedAsBuyer = 3, LeftForOthers = 4
}

export type sortOrderTypes = 'Date_DESC' | 'Date_ASC' | 'Rating_ASC' | 'Rating_DESC'

export class Feedback extends MongoObject {
  protected static collectionName: string = 'feedbacks'           // IMPORTANT

  public static MAX_FEEDBACK_NOTE: number = 255

  public auctionId: string = null              // the mongo Id of the auction that this feedback pertains to 
  public ratee: string = null                  // the flowAddress of the ratee
  public author: string = null                 // the flowAddress of the author (should equal bidder or seller field)
  public authorUserId: string = null           // the userId of the author
  public text: string = null
  public rating: number = null                 // for now, -1, 0, or 1 - could later do something different
  public authorRole: roleType = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  // client-only field not meant to be stored in db - utils_mongo.insertOne() and utils_mongo.insertMany() are instrumented to do this
  public _temp: { rateeAccount?: Account, authorAccount?: Account, momentHTML?: string } = {}

  constructor(po?: object, auctionId?: string, ratee?: string, author?: string, authorUserId?: string, text?: string, rating?: number, authorRole?: roleType) {
    super()
    if (po) this.injectPlainObject(po)
    if (auctionId) this.auctionId = auctionId
    if (ratee) this.ratee = utils_topshot.sansPrefix(ratee)
    if (author) this.author = utils_topshot.sansPrefix(author)
    if (authorUserId) this.authorUserId = authorUserId
    if (text) this.text = text
    if (rating != null) this.rating = rating
    if (authorRole) this.authorRole = authorRole
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    return true
  }

}


(async () => {
})();
